try{if(localStorage.getItem('pewniaki-push')){const card=document.getElementById('push-zacheta');if(card){card.hidden=true;}}}catch(e){}
